export enum PROPOSAL_STATUS {
  BORROWER_SIGNATURE_PENDING = 'BORROWER_SIGNATURE_PENDING',
  CANCELED = 'CANCELED',
  CANCELING_PENDING = 'CANCELING_PENDING',
  CNAB_PENDING = 'CNAB_PENDING',
  CREDIT_ERROR = 'CREDIT_ERROR',
  CREDIT_PENDING = 'CREDIT_PENDING',
  DEBT_TRANSFER_INVOICE_PENDING = 'DEBT_TRANSFER_INVOICE_PENDING',
  DEBT_TRANSFER_ERROR = 'DEBT_TRANSFER_ERROR',
  DEFAULT = 'DEFAULT',
  DENIED = 'DENIED',
  ENDORSEMENT_CREATED = 'ENDORSEMENT_CREATED',
  ERROR = 'ERROR',
  EXPIRED = 'EXPIRED',
  FINISHED = 'FINISHED',
  IN_PROGRESS = 'IN_PROGRESS',
  LENDER_SIGNATURE_PENDING = 'LENDER_SIGNATURE_PENDING',
  FINANCIAL_CONSULTANT_APPROVAL_PENDING = 'FINANCIAL_CONSULTANT_APPROVAL_PENDING',
  FINISHED_PENDING = 'FINISHED_PENDING',
  LENDER_APPROVAL_PENDING = 'LENDER_APPROVAL_PENDING',
  PIX_PROCESSING_ERROR = 'PIX_PROCESSING_ERROR',
  PIX_PROCESSING = 'PIX_PROCESSING_ERROR',
  REGISTRATION_PENDING = 'REGISTRATION_PENDING',
  RELEASED = 'RELEASED',
}

export const PROPOSAL_CANCELABLE_STATUSES = [
  PROPOSAL_STATUS.BORROWER_SIGNATURE_PENDING,
  PROPOSAL_STATUS.REGISTRATION_PENDING,
  PROPOSAL_STATUS.LENDER_SIGNATURE_PENDING,
  PROPOSAL_STATUS.LENDER_APPROVAL_PENDING,
  PROPOSAL_STATUS.DEBT_TRANSFER_INVOICE_PENDING,
];

export const PROPOSAL_DENIABLE_STATUSES = [
  PROPOSAL_STATUS.REGISTRATION_PENDING,
  PROPOSAL_STATUS.LENDER_SIGNATURE_PENDING,
  PROPOSAL_STATUS.LENDER_APPROVAL_PENDING,
];

export const PROPOSAL_APPROVABLE_STATUSES = [PROPOSAL_STATUS.LENDER_APPROVAL_PENDING];

export const PROPOSAL_INVOICE_ATTACHABLE_STATUSES = [PROPOSAL_STATUS.DEBT_TRANSFER_INVOICE_PENDING];

export const PROPOSAL_INVOICE_DOWNLOADABLE_STATUSES = [
  PROPOSAL_STATUS.BORROWER_SIGNATURE_PENDING,
  PROPOSAL_STATUS.LENDER_SIGNATURE_PENDING,
  PROPOSAL_STATUS.CNAB_PENDING,
  PROPOSAL_STATUS.ENDORSEMENT_CREATED,
  PROPOSAL_STATUS.CREDIT_PENDING,
  PROPOSAL_STATUS.CREDIT_ERROR,
  PROPOSAL_STATUS.IN_PROGRESS,
  PROPOSAL_STATUS.ERROR,
  PROPOSAL_STATUS.FINISHED_PENDING,
];

export const PROPOSAL_SIGNABLE_STATUSES = [PROPOSAL_STATUS.BORROWER_SIGNATURE_PENDING];

export const PROPOSAL_LENDER_SIGNABLE_STATUSES = [PROPOSAL_STATUS.LENDER_SIGNATURE_PENDING];

export const PROPOSAL_FINANCIAL_CONSULTANT_APPROVAL_STATUSES = [
  PROPOSAL_STATUS.FINANCIAL_CONSULTANT_APPROVAL_PENDING,
];
